export default {
  apiKey: "AIzaSyD_WUiK22Ra8FhbhW_rfPbmoLLm9y3JcoE",
  authDomain: "equfi-dceea.firebaseapp.com",
  databaseURL: "https://equfi-dceea.firebaseio.com",
  projectId: "equfi-dceea",
  storageBucket: "equfi-dceea.appspot.com",
  messagingSenderId: "710589322781",
  appId: "1:710589322781:web:38d0220b298713c67018f4",
  measurementId: "G-YHZPHJ6E7Z",
};
